import update from 'immutability-helper';
import { ActionType, defaultAction } from '../types';
import { ACTION_TYPES } from '../types/productConfigTypes';

export type ProductConfig = {
  service: string;
  parameter: string;
  value: string;
};

export type ProductConfigState = {
  data: ProductConfig[];
  error: any;
  isLoading: boolean;
};

const initialState: ProductConfigState = {
  data: [],
  error: null,
  isLoading: false,
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;

  switch (type) {
    case ACTION_TYPES.LOAD_PRODUCT_CONFIG_LIST:
      return update(state, {
        isLoading: {
          $set: true,
        },
      });
    case ACTION_TYPES.LOAD_PRODUCT_CONFIG_LIST_SUCCESS:
      return update(state, {
        data: {
          $set: payload.data ?? [],
        },
        isLoading: {
          $set: false,
        },
      });

    case ACTION_TYPES.LOAD_PRODUCT_CONFIG_LIST_FAILED:
      return update(state, {
        error: {
          $set: payload.reason,
        },
        isLoading: {
          $set: false,
        },
      });
    default:
      return state;
  }
};
